/**
 * Mirrors Automy.Core.Enums.Chat.ChatType (numeric + EnumMember wire value).
 */
const ChatType = Object.freeze({
  GeneralSupport: 1,
  EngineAI: 2,
  EmailSupport: 3,
  UserDefault: 4,
  AppBuilder: 5,
  EntityBuilder: 6,
  ProcessBuilder: 7,
  AgentBuilder: 8,
  ListBuilder: 9,
  AgentAI: 10,
  CreatorBuilder: 11,
  RpaFlowBuilder: 12,
  ReportBuilder: 13,
});

const CHAT_TYPE_WIRE = Object.freeze({
  [ChatType.GeneralSupport]: 'general-support',
  [ChatType.EngineAI]: 'engine-ai',
  [ChatType.EmailSupport]: 'email-support',
  [ChatType.UserDefault]: 'user-default',
  [ChatType.AppBuilder]: 'app-builder',
  [ChatType.EntityBuilder]: 'entity-builder',
  [ChatType.ProcessBuilder]: 'process-builder',
  [ChatType.AgentBuilder]: 'agent-builder',
  [ChatType.ListBuilder]: 'list-builder',
  [ChatType.AgentAI]: 'agent-ai',
  [ChatType.CreatorBuilder]: 'creator-builder',
  [ChatType.RpaFlowBuilder]: 'rpa-flow-builder',
  [ChatType.ReportBuilder]: 'report-builder',
});

const CHAT_TYPE_BY_WIRE = Object.freeze(
  Object.fromEntries(Object.entries(CHAT_TYPE_WIRE).map(([numeric, wire]) => [wire, Number(numeric)])),
);

const CHAT_TYPE_BY_NAME = Object.freeze(
  Object.fromEntries(Object.keys(ChatType).map((name) => [name.toLowerCase(), ChatType[name]])),
);

const toChatTypeNumber = (value) => {
  if (value == null || value === '') return null;
  const numeric = Number(value);
  if (!Number.isNaN(numeric) && CHAT_TYPE_WIRE[numeric]) return numeric;
  const normalized = String(value)
    .trim()
    .toLowerCase()
    .replace(/_/g, '-');
  if (CHAT_TYPE_BY_WIRE[normalized] != null) return CHAT_TYPE_BY_WIRE[normalized];
  if (CHAT_TYPE_BY_NAME[normalized.replace(/-/g, '')] != null) {
    return CHAT_TYPE_BY_NAME[normalized.replace(/-/g, '')];
  }
  return null;
};

export const sameChatType = (left, right) => {
  const leftNum = toChatTypeNumber(left);
  const rightNum = toChatTypeNumber(right);
  return leftNum != null && rightNum != null && leftNum === rightNum;
};

export default ChatType;
